import React, { useState, useEffect } from "react";
import {
  Backdrop,
  Button,
  DocumentsList,
  FormFieldSet,
  LogoLoader,
  Modal,
  NewTable,
  NewTableAdv,
  SmartTooltip,
  StatusTags,
  TableAdv,
  useFormHandler,
} from "../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../utils";
import { timesheetTableData } from "../../../../../assets/data/candidatesData";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../../hooks";
import {
  clearTimesheetData,
  getTimesheetsStart,
} from "../../../../../redux/slices/timesheets/timsheetSlice";
import { getEmployeeByUiidStart } from "../../../../../redux/slices/employee/employeeSlice";
import {
  clearPlacementsData,
  getAllPlacementsStart,
} from "../../../../../redux/slices/placements/placementsSlice";
import { DropDownFilteroptions } from "../../../../../assets/data/projectData";
import { TimesheetStatus } from "../../../../../assets/data/enumData";
import dayjs from "dayjs";
import { exactUTCDate } from "../../../../../utils/dateFormator";

const TimesheetsTab = () => {
  const [sortConfig, setSortConfig] = useState({
    field: "period.from",
    direction: -1,
  });
  //added for search
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    range: { from: "", to: "" },
    client: "",
    documentType: "",
    status: "",
  });

  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state?.employee?.employeeProfileUiid,
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const { loading, placements: placementsTableData } =
    useSelector((state) => state?.placement) || [];
  const {
    loading: loadingTimesheet,
    timesheets: timesheetDataForTable,
    totalCount,
  } = useSelector((state) => state?.timesheet) || [];

  const isLoading = loading;
  const { page, limit, setPage, handleLimitChange } = usePagination(10);

  // useEffect(() => {
  //   if (employeeProfileUiid) {
  //     console.log("triggered");
  //     dispatch(
  //       getEmployeeByUiidStart({
  //         uiid: employeeProfileUiid,
  //         // tab: "placementsTab",
  //         ret: "placements",
  //       })
  //     );
  //   }
  //   return () => {
  //     dispatch(clearPlacementsData());
  //   };
  // }, [employeeProfileUiid]);

  // useEffect(() => {
  //   dispatch(
  //     getAllPlacementsStart({
  //       fil: { uiid: { type: "IN", value: placements } },
  //       cache: false,
  //     })
  //   );
  // }, [employeeProfileUiid, loadedTabs, dispatch]);

  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };

  const tableData = timesheetDataForTable?.data || [];
  const columns = [
    {
      key: "endClient",
      label: "Client Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.clientId?.businessName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-1">
            <span className="text-info">
              {row?.clientId?.businessName || "-"}
            </span>
          </div>
        </SmartTooltip>
      ),
      sortfun: () => handleSort("clientId"),
    },

    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.placementId?.jobInfo?.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <span className="text-info line-clamp-1!">
            {row?.placementId?.jobInfo?.jobTitle || "-"}
          </span>
        </SmartTooltip>
      ),
      sortable: false,
    },
    {
      key: "from",
      label: "From",
      render: (row) =>
        // dateFormator(row?.placementId?.jobInfo?.startDate, "month-day-year"),
        exactUTCDate(row?.period?.from),
      // render: (row) => dateFormator(row.from, "month-day-year"),
      sortable: false,
    },
    {
      key: "to",
      label: "To",
      render: (row) =>
        // dateFormator(row?.placementId?.jobInfo?.endDate, "month-day-year"),
        exactUTCDate(row?.period?.to),
      sortable: false,
    },
    {
      key: "attachment",
      label: "Attachment",
      render: (row) => (
        <div
          className="flex items-center gap-1 flex-row cursor-pointer"
          // onClick={() => handleclick()}
          onClick={() => {
            setIsModalOpen(true);
            setSelectedDocuments(
              row?.attachments?.map((file, index) => ({
                id: index,
                filePath: file,
                name: `Timesheet Attachment ${index + 1}`,
              })),
            );
          }}
        >
          {/* {console.log("row?.documents",row?.attachments)} */}
          <span className="text-linkblue">
            {row?.attachments?.length || 0} Docs{" "}
          </span>
          <div>
            <Button
              type="icon"
              icon="download"
              size="xs"
              variant="text"
              color="black"
            />
          </div>
        </div>
      ),
      sortable: false,
    },
    {
      key: "submittedOn",
      label: "Submitted On",
      render: (row) => {
        const entry = [...(row?.auditHistory || [])]
          .reverse()
          .find((item) => item.status === 2);
        return exactUTCDate(entry ? entry.timestamp : null);
      },
      sortable: false,
    },
    {
      key: "totalHrs",
      label: "Total Hrs",
      render: (row) => {
        const entry = row?.dailyEntries?.reduce(
          (total, entry) => total + entry.th,
          0,
        );
        return parseFloat(entry?.toFixed(2)) || 0;
      },
      sortable: false,
    },
    {
      key: "TotalBillableHrs",
      label: "Total Billable Hrs",
      sortable: false,
      render: (row) => {
        const entry = row?.dailyEntries?.reduce(
          (total, entry) => total + entry.tbh,
          0,
        );
        return parseFloat(entry?.toFixed(2)) || 0;
      },
    },
    {
      key: "status",
      label: "Status",
      render: (row) => {
        return (
          <StatusTags
            tag={
              TimesheetStatus.find((status) => status.value === row?.status)
                ?.label || "-"
            }
          />
        );
      },
      sortable: false,
    },
    {
      key: "source",
      label: "Source",
      render: (row) => <span className="">{"-"}</span>,
      // render: (row) => <span className="text-info">{row.source}</span>,
      sortable: false,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Link
            to="/employee/employee-profile/timesheet"
            state={{
              uiid: row?.placementId?.uiid, //here uiid is placementID
              timesheetId: row?.uiid,
              employeeId: row?.employeeId?.uiid,
              dataId: row?._id,
            }}
          >
            <Button
              type="icon"
              icon="visibility"
              size="xs"
              variant="text"
              color="black"
            />
          </Link>

          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  useEffect(() => {
    dispatch(
      getTimesheetsStart({
        page: page,
        limit: limit,
        // fil: { uiid: { type: "IN", value: placements } },
        filters: {
          employeeId: { type: "NONE", value: employeeProfileUiid },
          ...(formData.client && {
            clientId: { type: "NONE", value: formData.client.value },
          }),
          ...(formData.status && {
            status: { type: "NONE", value: formData.status },
          }),
          ...(formData.range.from &&
            formData.range.to && {
              period: {
                type: "RANGE",
                value: {
                  from: dayjs(formData.range.from).format("YYYY-MM-DD"),
                  to: dayjs(formData.range.to).format("YYYY-MM-DD"),
                },
              },
            }),
        },
        cache: false,
        sort: { [sortConfig.field]: sortConfig.direction },
        // ret: "uiid entityId jobInfo.entityType",
        ref: "Employee Client Placement",
        // incl: "businessName",
      }),
    );
    // getAllPlacementsStart({
    //   page: page,
    //   limit: limit,
    //   // fil: { uiid: { type: "IN", value: placements } },
    //   // cache: false,
    //   // // ret: "uiid entityId jobInfo.entityType",
    //   // ref: "Entity",
    //   // incl: "businessName"
    //   // fil: { uiid: { type: "IN", value: placements } },
    //   fil: { employeeId: { type: "NONE", value: employeeProfileUiid } },
    //   cache: false,
    //   // ret: "uiid entityId jobInfo.entityType",
    //   ref: "Entity",
    //   incl: "businessName",
    //   // ref
    // })

    return () => {
      dispatch(clearPlacementsData());
    };
  }, [dispatch, page, limit, sortConfig, formData]); // Empty array will cause it to run once when the component mounts

  const handleFilterClear = () => {
    handleChange("range", { from: "", to: "" });
    handleChange("client", "");
    handleChange("documentType", "");
    handleChange("status", "");
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <TableAdv
        tableId={"employee_timesheetstab"}
        rows={mappedRows}
        columns={columns}
        // toolbarRight={[
        //   { customSearch: false },
        //   { filterButton: false },
        //   { DropdownMenu: false },
        // ]}
        // showSlNo
        //
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          add: [
            {
              component: (
                <div className="flex items-center gap-2 mr-2">
                  {(formData.client ||
                    formData.documentType ||
                    formData.status ||
                    formData.range.from ||
                    formData.range.to) && (
                    <div className="flex justify-end">
                      <Button
                        title="Clear"
                        size="sm"
                        onClick={handleFilterClear}
                      />
                    </div>
                  )}
                  <div className="min-w-[200px]">
                    <FormFieldSet
                      type="datepickerRange"
                      noTitle
                      placeholder="Select From and To Date"
                      size="sm"
                      value={formData.range}
                      onChange={(value) => handleChange("range", value)}
                      showDropdown={false}
                    />
                  </div>
                  <div className="min-w-[150px]">
                    <FormFieldSet
                      type="allTimesheetClients"
                      noTitle
                      placeholder="Select Client"
                      value={formData.client}
                      onChange={(value) => handleChange("client", value)}
                      size="sm"
                      showSearch
                      filters={{ employeeId: employeeProfileUiid }}
                    />
                  </div>
                  {/* <div className="min-w-[150px]">
              <FormFieldSet
                type="select"
                noTitle
                placeholder=" Select Document Type"
                value={formData.documentType}
                onChange={(value) => handleChange("documentType", value)}
                size="sm"
                options={DropDownFilteroptions}
              />
            </div> */}
                  <div className="min-w-[150px]">
                    <FormFieldSet
                      type="select"
                      noTitle
                      placeholder=" Select Status"
                      value={formData.status}
                      onChange={(value) => handleChange("status", value)}
                      options={TimesheetStatus}
                      size="sm"
                    />
                  </div>
                </div>
              ),
            },
          ],
        }}
      />
      <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default TimesheetsTab;
